<template>
  <div>
    <v-row class="">
      <v-col
        v-for="(data, index) in datas"
        :key="index"
        cols="12"
        sm="6"
        class="text-start"
        :class="index > 1 ? 'pt-2' : ''"
      >
        <v-card
          class="pa-2 px-lg-3 d-flex align-center mouse-cursor"
          flat
          :color="
            $vuetify.theme.dark ? data.darkModeColor : data.backgroundColor
          "
        >
          <v-row align="center">
            <v-col cols="auto">
              <v-icon :color="data.iconColor" size="20">
                {{ data.icon }}
              </v-icon>
            </v-col>

            <v-col cols class="px-0">
              <div
                class="text-start body-2 textLight--text ps-1 text-ellipse-1"
                style="opacity: 0.8"
              >
                {{ data.text }}
              </div>
            </v-col>

            <v-col cols="auto">
              <div class="subtitle-1 textLight--text text-ellipse-1">
                {{ data.value }}
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      datas: [
        {
          icon: "mdi-sync",
          iconColor: "primary",
          text: this.$t("course.onGoingCourses.onGoingCourses"),
          key: "Ongoing",
          value: 0,
          backgroundColor: "#DED4FA",
          darkModeColor: "#3807c1",
        },
        {
          icon: "mdi-check-circle-outline",
          iconColor: "accent",
          text: this.$t("course.statistics.completedCourses"),
          key: "Completed",
          value: 0,
          backgroundColor: "#E1FCEF",
          darkModeColor: "#5dbb8e",
        },
        {
          icon: "mdi-alert-outline",
          iconColor: "error",
          text: this.$t("course.statistics.aboutToDue"),
          key: "Due",
          value: 0,
          backgroundColor: "#FFDCDC",
          darkModeColor: "#f39797",
        },
        {
          icon: "mdi-alert-octagon-outline",
          iconColor: "error",
          text: this.$t("course.assignedCourses.assignedCourses"),
          key: "Assigned",
          value: 0,
          backgroundColor: "#FFC5B3",
          darkModeColor: "#fb7c54",
        },
      ],
    };
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },

  apollo: {
    getTraineeStatistics() {
      return {
        query: require("@/app/user-module/api/query/getTraineeStatistics.gql"),
        variables: {
          id: this.userId,
        },
        result({ data, loading }) {
          if (data && data.getTraineeStatistics) {
            this.datas.map(obj => {
              if (obj.key === "Completed") {
                obj.value = data.getTraineeStatistics.completedCourses
                  ? data.getTraineeStatistics.completedCourses
                  : 0;
              }
              if (obj.key === "Ongoing") {
                obj.value = data.getTraineeStatistics.ongoingCourses
                  ? data.getTraineeStatistics.ongoingCourses
                  : 0;
              }
              if (obj.key === "Due") {
                obj.value = data.getTraineeStatistics.aboutDueCourses
                  ? data.getTraineeStatistics.aboutDueCourses
                  : 0;
              }
              if (obj.key === "Assigned") {
                obj.value = data.getTraineeStatistics.assignedCourses
                  ? data.getTraineeStatistics.assignedCourses
                  : 0;
              }
            });
          } else {
            this.datas.map(obj => {
              obj.value = 0;
            });
          }

          this.loading = loading;
        },
      };
    },
  },
  methods: {
    refetch() {
      this.$apollo.queries.getTraineeStatistics.refetch();
    },
  },
};
</script>
